import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Container, List, Typography } from "@material-ui/core";
import ItemFormulario from "./ItemFormulario";
import { ESTADISTICAS_OSPEDYC } from "../../../utils/constants";
import { cargarEstadisticas } from "../../../actions/miOspedyc/estadisticasMiOspedyc";
import { useDispatch, useSelector } from "react-redux";
import { getFormulariosPorCategoria } from "../../../actions/miOspedyc/abmFormulariosMiOspedyc";
import LoadingBeforeViewData from './../../compartidos/LoadingBeforeViewData';

const useStyles = makeStyles((theme) => ({
    root: {
        minHeight: '100%',
        marginTop: "1.5rem",
        marginBottom: "1rem"
    },
    title: {
        fontWeight: "bold",
        marginBottom: "1rem"
    },
    rootList: {
        width: '100%',
        marginTop: "1rem"
    }
}));

const Formularios = (props) => {

    const classes = useStyles();
    const dispatch = useDispatch()

    const { formulariosPorCategoriaMiOspedyc } = useSelector((state) => state.formulariosMiOspedyc);

    useEffect(() => {
        dispatch(cargarEstadisticas(ESTADISTICAS_OSPEDYC.FORMULARIOS))
        dispatch(getFormulariosPorCategoria())
        // eslint-disable-next-line
    }, [])

    if (formulariosPorCategoriaMiOspedyc === null) {
        return <LoadingBeforeViewData />
    }

    return (
        <div className={classes.root}>
            <Container maxWidth="sm">
                <Typography align="center" variant="h4" color="primary" className={classes.title}>Formularios</Typography>
                <Typography align="center">En esta sección podrás descargar la documentación necesaria para el trámite que necesites gestionar.</Typography>
                <List
                    component="nav"
                    aria-labelledby="nested-list-subheader"
                    className={classes.rootList}
                >
                    {
                        formulariosPorCategoriaMiOspedyc.map(categoria => (
                            <ItemFormulario
                                key={categoria.idCategoriaFormularios}
                                text={categoria.descripcion}
                                items={categoria.formulariosMiOspedyc.map(formu => ({
                                    label: formu.descripcion,
                                    link: `${process.env.REACT_APP_URL}/${formu.archivo}`
                                }))}
                            />
                        ))
                    }
                </List>
            </Container>
        </div>
    );
};

export default Formularios
